import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { tutorialSteps } from "./tutorialSteps";
import LottiePlayer from "./LottiePlayer";
import LottieText from "./LottieText";
import "./LottieNavigation.css";

import { useLanguage } from '../../functions/setGetLanguage';
import { renderWithLineBreaksAndBold } from '../../functions/renderWithLineBreaksAndBold';

const TutorialPage = () => {
  const navigate = useNavigate();
  const [stepIndex, setStepIndex] = useState(0); // 0-based index

  const isLast = stepIndex === tutorialSteps.length - 1;

  const step = tutorialSteps[stepIndex];

  // language
  const { language } = useLanguage();

  const goToNext = () => {
    if (isLast) {
      navigate("/mode-selector");
    } else {
      setStepIndex((prev) => prev + 1);
    }
  };
  const goToPrevious = () => {
    if (stepIndex === 0) {
      return
    } else {
      setStepIndex((prev) => prev - 1);
    }
  };

  // swipe
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const minSwipeDistance = 40; // pixels

  const handleTouchStart = (item) => {
    setTouchEnd(null);
    setTouchStart(item.targetTouches[0].clientX);
  };

  const handleTouchMove = (item) => {
    setTouchEnd(item.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (typeof touchStart !== "number" || typeof touchEnd !== "number") return;
    const distance = touchStart - touchEnd;
    if (distance > minSwipeDistance){ 
      goToNext()
    }
    else if (distance < -minSwipeDistance) {
      goToPrevious()
    };
  };

  return (
    <div 
      style={{ width: "100vw", height: "100%", position: "relative", boxSizing: "border-box" , background:"white"}}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      className="wrapperMain"
    >
      <div className="white-bg"></div>
      <div className="lottie-main">
        <div
          style={{
            width: "min(100vw, 1024px)",
            height: "50vh",
            // maxHeight: "60dvh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          {step.type === "video" ? (
            <video
              src={step.source}
              autoPlay
              loop
              muted
              playsInline
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          ) : (
            <LottiePlayer animationData={step.source} />
          )}
        </div>

        <LottieText 
          title={renderWithLineBreaksAndBold(step[`title${language}`])} 
          subtitle={renderWithLineBreaksAndBold(step[`subtitle${language}`])} 
        />

        {step[`note${language}`] &&
          <p className="p-sidenote-bottom">{step[`note${language}`]}</p>
        }
      </div>

      {/* Navigation */}
      <button
        onClick={goToNext}
        className="nav-button"
        onFocus={(e) => e.currentTarget.blur()}
      >
        &gt;
      </button>

      <div className="dot-indicator-container">
        {tutorialSteps.map((_, i) => (
          <div key={i} className={`dot ${i === stepIndex ? "active" : ""}`} />
        ))}
      </div>
    </div>
  );
};

export default TutorialPage;
